/* unplugin-vue-components disabled */import script from "./RzApply.vue?vue&type=script&lang=ts&setup=true"
export * from "./RzApply.vue?vue&type=script&lang=ts&setup=true"

import "./RzApply.vue?vue&type=style&index=0&id=2045bb75&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2045bb75"]])

export default __exports__